module.exports = __webpack_public_path__ + "img/email.dd73b2e4.jpg";